<template>
    <div class="d-flex justify-content-start py-3">
        <v-btn rounded text color="primary" @click="cancelAction">
            {{ t('default::button.cancel') }}
        </v-btn>
        <v-btn
            v-if="can('api.v1.astm-devices.update') || can('api.v1.astm-devices.store')"
            color="primary"
            rounded
            class="ml-4"
            :loading="astmDevicesFormLoading"
            @click="saveAstmDevice()"
        >
            {{ t('default::button.save') }}
        </v-btn>
        <v-overlay :value="overlay" :z-index="zIndex" :opacity="0.9">
            <v-progress-circular
                class="astm-progress"
                :size="100"
                :width="10"
                color="#3cacb6"
                indeterminate
            ></v-progress-circular>
            <p class="loader-message">
                {{ t('astm-devices::messages.image-is-being-created') }}
            </p>
        </v-overlay>
    </div>
</template>

<script>
export default {
    data() {
        return {
            astmDevicesFormLoading: false,
            overlay: false,
            zIndex: 500,
        };
    },
    computed: {
        id() {
            return this.$store.state.astm_devices.astm_device.id;
        },
        ipAddress() {
            return this.$store.state.astm_devices.ip;
        },
    },
    methods: {
        cancelAction() {
            return this.$emit('reloadAstmDevice');
        },
        async saveAstmDevice() {
            !this.id ? (this.overlay = true) : (this.overlay = false);
            this.astmDevicesFormLoading = true;
            this.$store.dispatch('astm_devices/resetErrorMessages');
            const data = _.clone(this.$store.state.astm_devices.astm_device);
            if (this.id) {
                if (data.network_method === 'dhcp') {
                    delete data.proxy_ip_address;
                }

                delete data.network_method;
                delete data.proxy_mac_address;
                delete data.ip_address_mask_two;
                delete data.listening_port;
                delete data.user.username;
                delete data.user.password;
            }
            axios({
                method: this.id ? 'put' : 'post',
                url: this.id
                    ? route('api.v1.astm-devices.update', { astm_device: this.id })
                    : route('api.v1.astm-devices.store'),
                data,
            })
                .then((response) => {
                    if (this.id) {
                        this.$root.notify(
                            'info',
                            t('default::notification.success'),
                            t('astm-devices::notification.update')
                        );
                    }

                    if (!this.id) {
                        this.$root.notify(
                            'info',
                            t('default::notification.create'),
                            t('astm-devices::notification.create')
                        );
                    }

                    _.delay(() => {
                        this.$root.goTo(route('astm-devices.get', { astm_device: response.data.data.id }));
                    }, 1000);
                })
                .catch((error) => {
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('astm_devices/setErrorMessages', error.response.data.errors);
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() =>
                    _.delay(() => {
                        this.astmDevicesFormLoading = false;
                        this.overlay = false;
                    }, 1400)
                );
        },
    },
};
</script>

<style scoped>
.loader-message {
    color: #3cacb6;
    margin: 20px auto;
    font-size: 26px;
    font-weight: 700;
}

.astm-progress {
    left: 37%;
}
</style>
